<script setup>
import Alert from "@/components/common/Alert.vue";
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog
    v-model="act"
    width="550px"
    min-height="700px"
>
<v-card
    min-height="500px"
>
<v-toolbar
    flat
     height="50px"
    color="#E13532"
    dark
>
    <v-toolbar-title>
         画像ギャラリー
    </v-toolbar-title>
    <v-spacer />
    <v-icon
        @click="act=false"
    >
        mdi-close
    </v-icon>
</v-toolbar>
<v-card-text v-if="items.length==0">
<Alert 
	messagetitle="画像がアップロードされていません"
	message="以前アップロードされた画像をギャラリーから選択して利用できます。"
	blockheight="400px"
/>
</v-card-text>
<v-card-text class="mt-3" v-else>
    <v-card min-height="450px" class="py-0 px-0" flat>
  <v-row>
    <v-col
      v-for="item in items"
      :key="item.id"
      class="d-flex child-flex"
      cols="4"
    >
      <v-card
          @click="img_select(item[0])"
       >
      <v-img
        :src="`https://search.qlipper.jp/cont/dsp?id=` + item[0]"
        :aspect-ratio="16/9"
        class="grey lighten-2"
        style="text-align:end;"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
        <v-icon
            dark
            @click="delgrapth(item[0])"
        >
            mdi-delete
        </v-icon>
      </v-img>
          <v-card-text>
            <span>{{ item[1] }}</span>
          </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</v-card>
</v-card-text>
<v-card-actions style="justify-content:center" v-if="items.length!=0">
  <div class="text-center">
    <v-pagination
      v-model="page"
      total-visible="10"
      :length="len"
      circle
      @input="input"
      @prev="prev"
      @next="next"
    ></v-pagination>
  </div>

</v-card-actions>
</v-card>
</v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            act : false,
            page : 1,
            items : [],
            count : 0,
            mode  : 0,
            len   : 1,
            max_len : 9,
        }
    },
    methods : {
        open : function(mode){
            this.page=1;
            this.mode = mode;
            this.act = true;
            this.list();
        },
        input        : function(data){
            this.page = data;
            this.items = [];
            this.list();
        },
        prev         : function(){
            this.items = [];
            this.list();
        },
        next         : function(){
            this.items = [];
            this.list();
        },
        delgrapth : async function(id){
            let params = new URLSearchParams();
            params.append('id',id);
            params.append("page",this.page);
            params.append("max",this.max_len);

            await axios.post("https://search.qlipper.jp/cont/del",params)
            .then(response => {
                if(response.data.data.length==0)
                {
                    this.items = [];
                    this.len = 0;
                    return;
                }
                this.count = response.data.count;
                this.items = response.data.data;
                this.len = Math.ceil( Number(this.count) / this.max_len  );
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });

        },
        list : async function(){
            let params = new URLSearchParams();
            params.append('page',this.page);
            params.append("max",this.max_len);
            await axios.post("https://search.qlipper.jp/cont/list",params)
            .then(response => {
                if(response.data.data.length==0)
                {
                    this.items = [];
                    this.len = 0;
                    return;
                }

                this.count = response.data.count;
                this.items = response.data.data;
                this.len = Math.ceil( Number(this.count) / this.max_len  );
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        img_select : function(uuid){
            if(this.mode == 1)
            {
                this.$emit("selected_img",{"uuid":uuid});
            }
        },
    },
    mounted : function(){
    },
}
</script>
